import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeLongTextCell: null, // Will store {rowId, columnId} when a cell is being edited
  activeHoverImage: null, // Will store {rowId, columnId} when a hover image is being shown
  selectedRows: [],
  errorFields: [], // Array of {rowId, fields} objects
};

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setActiveLongTextCell: (state, action) => {
      // action.payload should be either null or {rowId, columnId}
      state.activeLongTextCell = action.payload;
    },
    setActiveHoverImage: (state, action) => {
      state.activeHoverImage = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    setErrorFields: (state, action) => {
      state.errorFields = action.payload;
    },
  },
});

export const {
  setActiveLongTextCell,
  setActiveHoverImage,
  setSelectedRows,
  setErrorFields,
} = tableSlice.actions;
export default tableSlice.reducer;

// this file is being used to manage the active long text cell
// so we can apply a higher z-index to the <td/> containing the active cell
// this will help us get rid of the stacking context issue
